"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _subHours = _interopRequireDefault(require("date-fns/subHours"));
var _startOfYesterday = _interopRequireDefault(require("date-fns/startOfYesterday"));
var _endOfYesterday = _interopRequireDefault(require("date-fns/endOfYesterday"));
var _startOfMonth = _interopRequireDefault(require("date-fns/startOfMonth"));
var _subMonths = _interopRequireDefault(require("date-fns/subMonths"));
var _endOfMonth = _interopRequireDefault(require("date-fns/endOfMonth"));
var _startOfYear = _interopRequireDefault(require("date-fns/startOfYear"));
var _subYears = _interopRequireDefault(require("date-fns/subYears"));
var _endOfYear = _interopRequireDefault(require("date-fns/endOfYear"));
var _startOfToday = _interopRequireDefault(require("date-fns/startOfToday"));
var _endOfToday = _interopRequireDefault(require("date-fns/endOfToday"));
var _subDays = _interopRequireDefault(require("date-fns/subDays"));
var _startOfDay = _interopRequireDefault(require("date-fns/startOfDay"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var predefinedRanges = [{
  id: 'TODAY',
  displayName: 'Today',
  dateTimeRange: function dateTimeRange() {
    var today = {
      startDate: (0, _startOfToday["default"])(),
      endDate: (0, _endOfToday["default"])()
    };
    return today;
  }
}, {
  id: 'LAST_HOUR',
  displayName: 'Last Hour',
  dateTimeRange: function dateTimeRange() {
    var now = new Date();
    var lastHour = {
      startDate: (0, _subHours["default"])(now, 1),
      endDate: now
    };
    return lastHour;
  }
}, {
  id: 'YESTERDAY',
  displayName: 'Yesterday',
  dateTimeRange: function dateTimeRange() {
    var yesterday = {
      startDate: (0, _startOfYesterday["default"])(),
      endDate: (0, _endOfYesterday["default"])()
    };
    return yesterday;
  }
}, {
  id: 'LAST_X_DAYS',
  displayName: 'Last X Days',
  selectedDisplayName: ['Last', 'Days'],
  dateTimeRange: function dateTimeRange(x) {
    var now = new Date();
    var lastXDays = {
      startDate: (0, _startOfDay["default"])((0, _subDays["default"])(now, x || 1)),
      endDate: (0, _endOfToday["default"])()
    };
    return lastXDays;
  },
  hasArgument: true
}, {
  id: 'THIS_MONTH',
  displayName: 'This Month',
  dateTimeRange: function dateTimeRange() {
    var now = new Date();
    var thisMonth = {
      startDate: (0, _startOfMonth["default"])(now),
      endDate: (0, _endOfToday["default"])()
    };
    return thisMonth;
  }
}, {
  id: 'LAST_MONTH',
  displayName: 'Last Month',
  dateTimeRange: function dateTimeRange() {
    var now = new Date();
    var lastMonth = {
      startDate: (0, _subMonths["default"])((0, _startOfMonth["default"])(now), 1),
      endDate: (0, _endOfMonth["default"])((0, _subMonths["default"])(now, 1))
    };
    return lastMonth;
  }
}, {
  id: 'LAST_X_MONTHS',
  displayName: 'Last X Months',
  selectedDisplayName: ['Last', 'Months'],
  dateTimeRange: function dateTimeRange(x) {
    var now = new Date();
    var lastXMonths = {
      startDate: (0, _startOfDay["default"])((0, _subMonths["default"])(now, x || 1)),
      endDate: (0, _endOfToday["default"])()
    };
    return lastXMonths;
  },
  hasArgument: true
}, {
  id: 'THIS_YEAR',
  displayName: 'This Year',
  dateTimeRange: function dateTimeRange() {
    var now = new Date();
    var thisYear = {
      startDate: (0, _startOfYear["default"])(now),
      endDate: (0, _endOfToday["default"])()
    };
    return thisYear;
  }
}, {
  id: 'LAST_YEAR',
  displayName: 'Last Year',
  dateTimeRange: function dateTimeRange() {
    var now = new Date();
    var lastYear = {
      startDate: (0, _subYears["default"])((0, _startOfYear["default"])(now), 1),
      endDate: (0, _endOfYear["default"])((0, _subYears["default"])(now, 1))
    };
    return lastYear;
  }
}];
var _default = predefinedRanges;
exports["default"] = _default;